export default __webpack_public_path__ + "fonts/Aeonik-Bold_190284e9c081cb156f0278bbb08c6acf.woff2";